import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { text } from '@carvana/helios-styles';
import useSaleEndsIn from '@hooks/useSaleEndsIn';

import {
  getColorFromState,
  getLabelFromState,
  getTimeRemaining,
  states
} from '../utils';
import TimerText from '../TimerText';

const { UPCOMING, LIVE } = states;
const SaleTimer = ({ isLive }) => {
  const [showTimer, setShowTimer] = useState(false);
  const {
    start: startOfTimer,
    end: endOfTimer,
    currentTime,
    clearInterval,
    restartTimer
  } = useSaleEndsIn(); // times in seconds

  useEffect(() => {
    setShowTimer(true);
  }, []);

  useEffect(() => {
    restartTimer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLive]);

  useEffect(() => {
    if (currentTime >= endOfTimer) {
      clearInterval();
    }
    return () => {
      clearInterval();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTime, endOfTimer, clearInterval]);

  return (
    <div>
      { showTimer && (
        <TimerText
          label={ getLabelFromState(isLive ? LIVE : UPCOMING) }
          color={ text[getColorFromState(isLive ? LIVE : UPCOMING)] }
          time={ getTimeRemaining({ startOfTimer, endOfTimer, currentTime }) }
        />
      )}
    </div>
  );
};

SaleTimer.propTypes = {
  isLive: PropTypes.bool
};

export default SaleTimer;
